export const PaymentSystemRestrictionMessage = {
  Profile: 'To use this payment method, fill in your profile.',
  Identity: 'To use this payment method, verify your identity.',
  Country: 'Not available in your country.',
  Account: 'Not available for your account.'
} as const
